<template>
    <Tooltip>
        <template #trigger="tooltipProps">
            <button
                class="rounded-full focus-visible:outline-2 focus-visible:outline-offset-1 focus-visible:outline-gray-700 focus-visible:z-100"
                type="button"
                v-bind="tooltipProps"
            >
                <InfoIcon
                    class="text-gray-500 cursor-help"
                    :class="[
                        props.size === '18px' ? 'size-4.5' : 'size-5',
                        {
                            'text-gray-500': !props.status || props.status === 'Info',
                            'text-red-700': props.status === 'Error',
                        },
                    ]"
                />
            </button>
        </template>
        <template #text>
            <div class="w-max max-w-60">{{ text }}</div>
        </template>
    </Tooltip>
</template>

<script setup lang="ts">
import InfoIcon from '../Icon/InfoIcon.vue';
import Tooltip from '../Tooltip/Tooltip.vue';

type HelpButtonProps = {
    text: string;
    status?: 'Info' | 'Error';
    size?: '18px' | '20px';
};

const props = defineProps<HelpButtonProps>();
</script>
